import { PRODUCT_STATUS_LABELS, type ProductStatus } from '@deizi/shared';

export const STATUS_BADGE: Record<ProductStatus, string> = {
  active: 'badge ok',
  prototype: 'badge info',
  idea: 'badge',
  archived: 'badge',
};

export function StatusBadge({ status, custom }: { status: ProductStatus; custom?: boolean }) {
  return (
    <>
      <span className={STATUS_BADGE[status]}>{PRODUCT_STATUS_LABELS[status]}</span>
      {custom ? <span className="badge solid">Sob encomenda</span> : null}
    </>
  );
}

/** Cover photo or the striped placeholder. */
export function Cover({
  url,
  height,
  label = 'sem foto ainda',
}: {
  url: string | null;
  height: number;
  label?: string;
}) {
  return url ? (
    <img className="thumb" src={url} alt="" style={{ width: '100%', height, objectFit: 'cover' }} />
  ) : (
    <div className="ph" style={{ height }}>
      {label}
    </div>
  );
}
